import styled from 'styled-components';

export const AccountsSection = styled.div`
  padding: 0;
`;

export const AccountsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AccountsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0 4px;
`;

export const SectionTitle = styled.h4`
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  color: #62748e;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const UnreadBadge = styled.div`
  background: linear-gradient(90deg, #fef2f2 0%, rgba(255, 226, 226, 0.5) 100%);
  border: 1px solid #ffc9c9;
  border-radius: 12px;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  gap: 4px;

  &.platform-badge {
    position: absolute;
    top: -5px;
    right: -3px;
    min-width: 16px;
    height: 16px;
    border-radius: 50%;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-weight: 600;
    color: #ffffff;
    box-shadow: 0px 4.8px 4.8px 0px #00000040;
  }

  &.platform-badge.whatsapp {
    background: #33ed58;
  }

  &.platform-badge.instagram {
    background: linear-gradient(90deg, #ad46ff 0%, #f6339a 50%, #ff6900 100%);
    top: -6px;
    right: -5px;
  }

  &.platform-badge.facebook {
    background: #2d6cdf;
  }

  &.platform-badge.imap {
    background: #0277ff;
  }

  &.user-badge {
    background: #2d6cdf;
    color: #ffffff;
    font-weight: 600;
    font-size: 9px;
    border: none;
    padding: 0;
    min-width: 16px;
    height: 16px;
    border-radius: 50%;
    box-shadow: 0px 4.8px 4.8px 0px #00000040;
  }
`;

export const UnreadCount = styled.span`
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  color: #c10007;
`;

export const PlatformsBlock = styled.div`
  height: 50px;
  margin: 10px 0;
  border-radius: 10px;
  background: #f1f5f9cc;
  box-shadow: 0px 2px 4px 0px #0000000d inset;
  padding: 6px;
  display: flex;
  align-items: center;

  @media (max-width: 558px) {
    height: auto;
    display: block;
  }

  @media (max-width: 396px) {
    display: flex;
  }
`;

export const PlatformItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }

  &.active {
    background: #ffffff;
    box-shadow: 0px 1px 3px 0px #0000001a;
    border-radius: 8px;
    padding: 6px 5px;
  }

  @media (max-width: 558px) {
    margin-bottom: 16px;
    /* &:first-child {
      margin-top: 16px;
    } */
  }

  @media (max-width: 396px) {
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export const PlatformIconBlock = styled.div`
  position: relative;
  display: flex;
`;

export const PlatformIcon = styled.img`
  width: 28px;
  height: 28px;
`;

export const PlatformIconWrapper = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 40%;
  background: ${({ $bg }) => $bg};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const PlatformName = styled.h5`
  font-weight: 500;
  font-size: 12px;
  color: #212529;
  margin-left: 6px;
  margin: 0 0 0 6px;

  @media (max-width: 396px) {
    display: none;
  }
`;

export const UserAccountsGrid = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 9px 0;
  border-top: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  margin-left: 8px;

  /* Limit to 2 rows with scrolling */
  max-height: 88px; /* 2 rows: (32px avatar + 4px badge space) * 2 + 6px gap + 18px padding */
  overflow-y: auto;
  overflow-x: hidden;

  /* Scrollbar matching ChatSingle style */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;

export const UserAccountItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  .platform-badge {
    position: absolute;
    top: -2px;
    right: -2px;
  }
`;

export const UserAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);
  object-fit: cover;
  object-position: center;
`;
